const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M35 32h8.224A12.777 12.777 0 0 0 56 19.224v-.002c0-.855-.339-1.674-.944-2.278A3.217 3.217 0 0 0 52.778 16H11.222c-.855 0-1.674.339-2.278.944A3.217 3.217 0 0 0 8 19.222v.002A12.777 12.777 0 0 0 20.776 32H29",
    style: {
      fill: "none",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 25v21.915A4.085 4.085 0 0 0 13.085 51h37.83A4.085 4.085 0 0 0 55 46.915V25M44 16v-4.021A1.979 1.979 0 0 0 42.021 10H21.979A1.979 1.979 0 0 0 20 11.979V16",
    style: {
      fill: "none",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 31c0-.796-.316-1.559-.879-2.121A2.996 2.996 0 0 0 32 28h-.002A2.999 2.999 0 0 0 29 30.998V34c0 .796.316 1.559.879 2.121a2.996 2.996 0 0 0 4.242 0A2.996 2.996 0 0 0 35 34v-3zM18 47h-2.596A2.403 2.403 0 0 1 13 44.596V42",
    style: {
      fill: "none",
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/companyIcon.482254ed.svg";
export { ForwardRef as ReactComponent };